<template>
  <v-dialog :value="dialog" max-width="450" @click:outside="close" @keydown.esc="close">
    <v-card>
      <v-card-title class="headline">Desvincular Legajo</v-card-title>

      <v-card-text v-if="legajo" class="pt-3">
        <p class="fs-16 mb-5">
          ¿Desea desvincular a <b>{{ legajo.name }} {{ legajo.surname }}</b> (Legajo N° {{ legajo.nro_legajo }})?
        </p>
        <BaseDatePicker label="Fecha de desvinculación" name="finish_date" v-model="finish_date" :rules="'required'"
          :validationErrors="errors" />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text :disabled="loading" @click="close">Cancelar</v-btn>
        <v-btn color="green darken-1" text :loading="loading" @click="confirm">Desvincular</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import BaseDatePicker from "@/components/BaseDatePicker.vue";

export default {
  components: { BaseDatePicker },
  props: {
    dialog: Boolean,
    legajo: Object,
  },
  data() {
    return {
      finish_date: null,
      loading: false,
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        const today = new Date();
        today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
        this.finish_date = today.toISOString().substr(0, 10);
        this.$validator.reset();
      }
    },
  },
  methods: {
    close() {
      this.$emit("updateDialog", false);
    },
    async confirm() {
      if (!(await this.$validator.validate())) return;

      this.loading = true;
      generalService
        .query({ id: this.legajo.id, finish_date: this.finish_date }, Constant.SECTION_LEGAJOS + "/unlink")
        .then((response) => {
          if (response.status) {
            this.$toast.success("El legajo se desvinculó correctamente.", "OK");
            this.close();
            this.$emit("loadList");
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((e) => {
          console.log(e);
          this.$toast.error("Error exception", "Error");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
